// extracted by mini-css-extract-plugin
export default {"aboutUsContainer":"AboutUs_aboutUsContainer__dw16B"};